import axios from 'axios';
import { registerInterceptors } from './authInterceptor';

/**
 * Cliente único da aplicação.
 *
 * Tudo passa pelo BFF (`certidoes-app-api-authenticator`), que valida o token
 * do SmartPass e reassina a identidade para o certidoes-api. O caminho é
 * relativo de propósito: resolve na origem do portal em qualquer ambiente.
 * Com URL absoluta o build embutiria o host errado.
 */
const baseURL =
  process.env.REACT_APP_AUTHENTICATOR_SERVICE ||
  '/api/certidoes-app-api-authenticator/v1';

export const httpClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

registerInterceptors(httpClient);
